'use client'

import { Button } from '@mui/material'
import { motion } from 'framer-motion'
import { FaCheckCircle, FaArrowLeft } from 'react-icons/fa'
import { Link } from 'react-router-dom'

export default function ThankYouPage() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-[#0097b2] to-[#0195b1]">
            <motion.div
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white p-8 rounded-lg shadow-2xl w-96 text-center"
            >
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
                >
                    <FaCheckCircle className="text-green-500 text-6xl mx-auto mb-6" />
                </motion.div>
                <h1 className="text-3xl font-bold mb-4 text-gray-800">Thank You!</h1>
                <p className="mb-6 text-gray-600">Your submission has been received. We appreciate your interest!</p>
                <Link onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} to="/">
                    <Button style={{ borderRadius: '4px' }} className="bg-[#0097b2] hover:bg-balck-700 text-white font-bold py-2 px-4 transition duration-300 ease-in-out transform hover:scale-105 flex items-center justify-center">
                        <FaArrowLeft className="mr-2" />
                        Go Back
                    </Button>
                </Link>
            </motion.div>
        </div>
    )
}

